import React from "react";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import { styles } from "../styles/ProductLevelChallanData";

const Badge = ({ value, type }) => {
    const typeConfig = styles.badgeTypes[type];

    const typeStyle =
        typeof typeConfig === "function"
            ? typeConfig(value)
            : typeConfig || {};

    return (
        <TypographyCompo style={{ ...styles.badge, ...typeStyle }}>
            {value}
        </TypographyCompo>
    );
};

export default React.memo(Badge);
